import { DocumentationDetails } from './history';
import { GLOBAL_CONSTANT } from '../../constants/global.constant';

export class HistoryItemDetail {
  type!:
    | typeof GLOBAL_CONSTANT.HISTORY_ITEM.TYPE.NOTIFICATION
    | typeof GLOBAL_CONSTANT.HISTORY_ITEM.TYPE.DOCUMENTATION;

  message = '';
  timestamp = '';
  display!:
    | typeof GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.DEFAULT
    | typeof GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.WORKING
    | typeof GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.CRITICAL
    | typeof GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.WARNING
    | typeof GLOBAL_CONSTANT.HISTORY_ITEM.DISPLAY.INACTIVE;

  details: DocumentationDetails = new DocumentationDetails();
  open? = false;
  sensorID = 0;
  sensorName = '';
}
